import React, { useCallback, useEffect, useMemo } from 'react';

import * as S from './BottomModalStyles';
import Modal from '../Modal/Modal';

const BottomModal = (props) => {
	const { scrollTop, variation, disableChildPropsBinding, children, theme, errorMsg, ModalData = {} } = props;

	const modalData = {
		title: '',
		img: null,
		imgstyle: null,
		btnTxt: null,
		...ModalData,
		customWrapperClass: `${ModalData.customWrapperClass || ''} btmSheet ${variation ? `btmSheet--${variation}` : ''} ${theme ? `btmSheet--${theme}` : ''}`
	};

	return (
		<S.BottomModal>
			<Modal
				{...props}
				errorMsg={errorMsg}
				Modaldata={modalData}
				height='74%'
				type='bottom'>
				{children &&
					React.cloneElement(
						children
					)}
			</Modal>
		</S.BottomModal>
	);
};

export default BottomModal;
